import React from 'react';
import styled from 'styled-components';
import { colors } from '../../variables';
import { InputMessage } from '../';
import triangleImage from '../../../images/triangle.svg';

const getWidth = props => {
	if (props.width) return props.width;
	if (props.auto) return 'auto';
	return '100%';
};

const getBorderColor = (props, state = false) => {
	if (props.success) return colors.green.eco;
	if (props.warning) return colors.orange.spreader;
	if (props.error) return colors.red.warning;
	if (state === 'focus') return colors.blue.brommaLight;

	return '#96a0ad';
};

const StyledSelect = styled.select`
	position: relative;
	padding: 10px;
	padding-right: 30px;
	background: #fff;
	background-image: url(${triangleImage});
	background-position: right 10px center;
	background-repeat: no-repeat;
	background-size: 16px;
	cursor: pointer;
	appearance: none;
	-webkit-appearance: none;
	-moz-appearance: none;
	max-width: 100%;
	border-radius: 4px;
	border-style: solid;
	border-width: ${props => (props.noBorder ? '0' : '1px')};
	border-color: ${props => getBorderColor(props)};
	width: ${props => getWidth(props)};
	outline: 0;
	height: ${props => props.height || 'unset'};

	&::-ms-expand {
		display: none;
	}

	&:focus {
		border-color: ${props => getBorderColor(props, 'focus')};
	}
`;

class Select extends React.Component {
	render() {
		const {
			className,
			options = [],
			input,
			meta = {},
			keyByIndex = false,
			...rest
		} = this.props;

		const submitFailed = meta.submitFailed || false;
		const error = meta.error || false;

		const hasError = meta.invalid && meta.submitFailed;

		return (
			<div className={className}>
				<StyledSelect {...rest} {...input} error={hasError}>
					{options.length > 0 &&
						options.map((option, index) => (
							<option
								value={option.value}
								key={keyByIndex ? index : option.value}
								disabled={option.disabled}
								defaultChecked={option.defaultChecked}
							>
								{option.label}
							</option>
						))}

					{this.props.children}
				</StyledSelect>

				{submitFailed && error && <InputMessage>{error}</InputMessage>}
			</div>
		);
	}
}

export default Select;



// WEBPACK FOOTER //
// ./src/components/Common/Select/Select.js